import { Chip, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import ParceiroDataSet from "../../components/data/parceiroDataset";
import { useNavigate } from "react-router-dom";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { confirmAlert } from "react-confirm-alert";
import Filter from "./filter";
import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

const ParceiroListagem = () => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const [rows, setRows] = useState<Data>([]);
    const [filter, setFilter] = useState<string>("");
    const [isFiltered, setIsFiltered] = useState<boolean>(false);

    const dataSet: ParceiroDataSet = new ParceiroDataSet();
    const columns: GridColumns = [
        {
            field: "id",
            headerName: "#",
            type: "string",
            width: 100,
            headerAlign: "center",
            align: "center",
            editable: false,
        },
        {
            field: "codigoFornecedorSAP",
            headerName: t("pages.partners.text.sapCode"),
            type: "string",
            width: 100,
            headerAlign: "center",
            align: "center",
            editable: false,
        },
        {
            field: "apelido",
            headerName: t("common.nickname"),
            type: "string",
            width: 200,
            headerAlign: "center",
            align: "center",
            editable: false,
        },
        {
            field: "nome",
            headerName: t("common.name"),
            type: "string",
            flex: 1,
            headerAlign: "center",
            align: "center",
            editable: false,
        },
        {
            field: "status",
            headerName: t("pages.partners.text.status"),
            type: "string",
            width: 150,
            headerAlign: "center",
            align: "center",
            editable: false,
            renderCell: (item) => {
                return item.row.d_E_L_E_T_E == 1 ?
                    <Chip color='error' label='Inativo' variant="outlined" /> :
                    <Chip color="success" label='Ativo' variant="outlined" />;
            }
        }
    ];

    useEffect(() => {
        loadParceiros();
    }, []);

    const loadParceiros = async (value: string = "") => {
        let result = await dataSet.ListarTodos(value);
        setRows(result);
    }

    const handleClickRow = async (item: any) => {
        navigate(`/portal/parceiro/detalhe/${item.id}`);
    }

    const handleOpenFilter = () => {
        confirmAlert({
            title: t("pages.partners.text.partnersFilter"),
            message: '',
            willUnmount: () => { },
            customUI: ({ onClose }) => {
                return <Filter
                    onClickYes={(value: string) => {
                        if (value) {
                            loadParceiros(value);
                            setIsFiltered(true);
                        }
                        onClose();
                    }}
                    onClose={onClose}
                />
            }
        });
    }

    const handleRemoveFilter = () => {
        setIsFiltered(false);
        loadParceiros();
    }

    return (
        <>
            <div className="container">
                <div className="containerTitle">
                    <Typography
                        variant="h5"
                        fontFamily={"Co Headline Regular"}
                        gutterBottom
                        align="left"
                        marginLeft="15px"
                    >
                        {t("pages.partners.titleList")}
                    </Typography>
                </div>
                <div className="containerToolbar">
                    {
                        isFiltered &&
                        <Tooltip title={t("pages.partners.text.removeFilters")}>
                            <span>
                                <IconButton onClick={handleRemoveFilter}>
                                    <FilterAltOffIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    }
                    {
                        !isFiltered &&
                        <Tooltip title={t("pages.partners.text.partnersFilter")}>
                            <span>
                                <IconButton onClick={handleOpenFilter}>
                                    <FilterAltIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    }
                </div>
                <div className="insiderContainer" style={{ height: '75vh', marginTop: "2px" }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        rowsPerPageOptions={[50, 100, 250, 500]}
                        onRowClick={handleClickRow}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
            </div>
        </>
    );
};

export default ParceiroListagem;
